<template>
	<div class="activity-result">
		<van-loading v-if="loading && !options.isSubmit" class="activity-result__loading" size="24px">加载中...</van-loading>

		<!-- 提交成功 -->
		<template v-if="options.isSubmit">
			<div class="activity-result__main">
				<img class="activity-result__icon" :src="successIcon" alt="" />
				<div class="activity-result__title">提交成功</div>
			</div>
			<base-footer background-color="#ffffff">
				<van-button type="primary" block @click="clickGoAbout">{{ options.type === 'autoApply' ? '审核通过' : '进入详情页' }}</van-button>
			</base-footer>
		</template>

		<!-- 审核结果 -->
		<template v-else-if="!loading">
			<div class="activity-result__main">
				<img class="activity-result__icon" :src="statusIcon" alt="" />
				<div class="activity-result__title">{{ statusTitle }}</div>
				<div class="activity-result__desc" v-if="detail.auditStatus == 1">将在1～3个工作日完成审核，请耐心等待</div>
				<div class="activity-result__desc" v-if="detail.auditStatus == 3">{{ detail.failReason }}</div>
			</div>
			<base-footer background-color="#ffffff">
				<van-button v-if="detail.auditStatus == 3" type="primary" block @click="clickModify">修改报名资料</van-button>
				<van-button v-else type="primary" block @click="clickGoAbout">返回项目详情</van-button>
			</base-footer>
		</template>
	</div>
</template>

<script>
export default {
	name: 'ActivitySignAuditResult',
	data: () => ({
		loading: false,
		options: {},
		detail: {},
	}),
	computed: {
		user() {
			return this.$store.getters['user/getLoginInfo']
		},
		// 当前登录医生ID
		doctorId() {
			return this.user.userId || this.user.id || ''
		},
		fileBaseUrl() {
			return this.$config[this.$store.getters['user/getAppid']].fileBaseUrl
		},
		successIcon() {
			return `${this.fileBaseUrl}/icon-01.png`
		},
		statusIcon() {
			if (this.detail.auditStatus == 2) return `${this.fileBaseUrl}/icon-01.png`
			if (this.detail.auditStatus == 3) return `${this.fileBaseUrl}/icon-04.png`
			return `${this.fileBaseUrl}/icon-03.png`
		},
		statusTitle() {
			if (this.detail.auditStatus == 1) return '审核中'
			if (this.detail.auditStatus == 2) return '审核通过'
			if (this.detail.auditStatus == 3) return '审核不通过'
			return '未报名'
		},
	},
	created() {
		this.options = { ...this.$route.query }
		if (!this.options.isSubmit) {
			this.getActivityDetail()
		}
	},
	methods: {
		// 获取活动详情（审核状态）
		getActivityDetail() {
			this.loading = true
			this.$api.activity
				.activityDetail({
					id: this.options.activityId,
					doctorId: this.doctorId,
				})
				.then((res) => {
					this.loading = false
					if (!res.code && res.data) {
						this.detail = res.data
					}
				})
				.catch(() => {
					this.loading = false
				})
		},
		// 进入活动详情页
		clickGoAbout() {
			this.$router.replace(`/activity/sign/about?id=${this.options.activityId}`)
		},
		// 修改报名资料（审核拒绝时）
		clickModify() {
			this.$router.replace(`/activity/sign/audit?activityId=${this.options.activityId}`)
		},
	},
}
</script>

<style lang="less" scoped>
.activity-result {
	min-height: 100vh;
	background-color: #fff;
	box-sizing: border-box;

	&__loading {
		display: flex;
		justify-content: center;
		padding-top: 120px;
	}

	&__main {
		padding: 120px 16px 0;
		text-align: center;
	}

	&__icon {
		width: 80px;
		height: 80px;
		vertical-align: middle;
	}

	&__title {
		padding: 20px 0 6px;
		font-family: PingFang SC;
		font-size: 18px;
		font-weight: 500;
		text-align: center;
		color: #1f2329;
	}

	&__desc {
		font-family: PingFang SC;
		font-size: 14px;
		line-height: 22px;
		text-align: center;
		color: #8f959e;
		word-break: break-all;
	}
}
</style>
